// LinearGradient shim covering both `react-native-linear-gradient` and
// `expo-linear-gradient`. RN-Web can't render a true multi-stop gradient
// here, so we fall back to the first gradient stop as a solid background.
// Without this, gradient-backed UI renders fully transparent — e.g. the
// VoiceMealFlow record button (a gradient circle) became an invisible
// element. A solid fill keeps such surfaces visible and tappable.
import type { FC, ReactNode } from 'react';
import { View, type ViewProps } from 'react-native';

interface LinearGradientProps extends ViewProps {
  colors?: readonly string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
  locations?: readonly number[];
  children?: ReactNode;
}

const LinearGradient: FC<LinearGradientProps> = ({
  children,
  colors,
  style,
  ...rest
}) => (
  // `style` is applied last so an explicit backgroundColor still wins.
  <View
    {...rest}
    style={[colors && colors.length ? { backgroundColor: colors[0] } : null, style]}
  >
    {children}
  </View>
);

export default LinearGradient;
export { LinearGradient };
